module.exports = __webpack_public_path__ + "static/media/closeMsgActive.8bf471ea.svg";